export interface Palette {
  primaryColor: string;
  secondaryColor: string;
}

export const DEFAULT_PALETTE: Palette = { primaryColor: '#096559', secondaryColor: '#fc9210' };

